<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="courierTeleport.show"
            @hidden="closeModalCourierTeleport"
            body-class="p-0"
            header-class="p-1"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0 ml-2">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">แจ้งเตือนรายการสินค้าต้องห้ามในการจัดส่ง</h3>
                        </div>
                    </div>
                </div>
            </template>
            <div class="row">
                <div class="col-lg-12 text-center">
                    <div class="pt-2">
                        <img :src="require('../../assets/images/banner/Banner-teleport.jpeg')" alt="ImageBanner" width="500" height="650">
                    </div>
                    <div class="w-100 py-2">
                        <b-button variant="success"
                            class="px-6" 
                            @click="closeModalCourierTeleport">
                            ตกลง
                        </b-button>
                    </div>
                </div>
            </div> 
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalCourierTeleport" ,
    props: {
        courierTeleport: Object,
    },
    data(){
        return{
         
        }
    },
    mounted() {

    }, 
    methods: {
        closeModalCourierTeleport(){
            this.courierTeleport.show = false
        }
    }
}
</script>	